import { Inbox } from "lucide-react";
import type { ReactNode } from "react";

import { alsZin } from "@/lib/display";

import "./states.css";

type EmptyStateProps = {
  title: string;
  description: string;
  /** Bijvoorbeeld "Filters wissen" — de knop die de lege staat opheft. */
  action?: ReactNode;
  icon?: ReactNode;
  /** `compact` past in een kaart naast andere inhoud. */
  size?: "default" | "compact";
};

/**
 * Er is niets te tonen, en dat is geen probleem: geen resultaten binnen het
 * filter, geen rijen in deze selectie.
 *
 * Onderscheid met een fail-closed melding: dáár is er wél iets te tonen, maar
 * weigert het platform te rekenen omdat invoer ontbreekt. Dat is een andere
 * boodschap en een ander component (`FailClosedNotice`).
 *
 * De omschrijving staat altijd als volzin (`alsZin`, ronde 7): een reden van de
 * API met een kleine letter en zonder punt krijgt een hoofdletter en een punt.
 */
export function EmptyState({ title, description, action, icon, size = "default" }: EmptyStateProps) {
  return (
    <div className={size === "compact" ? "atl-empty-state atl-empty-state--compact" : "atl-empty-state"}>
      <span className="atl-empty-state__icon" aria-hidden>
        {icon ?? <Inbox size={22} strokeWidth={1.5} />}
      </span>
      <p className="atl-empty-state__title">{title}</p>
      <p className="atl-empty-state__description">{alsZin(description)}</p>
      {action && <div className="atl-empty-state__action">{action}</div>}
    </div>
  );
}
